import React, { useState, useEffect } from "react";

function LoadingModal({ isLoading, response, error, onClose }) {
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!isLoading) {
      if (error) {
        setMessage(`Error: ${error}`);
      } else if (response) {
        setMessage(`Success: ${response.message}`);
      }
    }
  }, [isLoading, response, error]);

  if (!isLoading && !response && !error) {
    return null; // Don't render the modal unless needed
  }

  return (
    <div className="modal" style={{ display: "block" }}>
      {" "}
      {/* Inline style for simplicity */}
      <div className="modal-content">
        {isLoading ? (
          <div className="spinner"></div> // Placeholder for spinner element
        ) : (
          <p>{message}</p>
        )}
        <button onClick={onClose}>Close</button>
      </div>
    </div>
  );
}

export default LoadingModal;
